import { render, staticRenderFns } from "./DeleteNoteModal.vue?vue&type=template&id=4961e8ae&"
import script from "./DeleteNoteModal.vue?vue&type=script&lang=ts&"
export * from "./DeleteNoteModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports